<template>
  <div class="lbv-reports animated fadeIn roundedCard">
    <div class="row">
      <div class="col-lg-12">
        <b-card v-if="$store.getters.roleID === Roles.SUPER_ADMIN || $store.getters.roleID === Roles.ADMIN">
          <h1 class="lbv-page-title">
            Reports
          </h1>
          <form @submit.prevent="downloadReports">
            <b-button
              variant="primary"
              type="submit"
              class="report rounded-pill"
            >
              <span class="download">Customer Overview</span>
            </b-button>
          </form>
        </b-card>
        <b-card v-if="$store.getters.roleID === Roles.MAINTENANCE || $store.getters.roleID === Roles.EXT_OPS || $store.getters.roleID === Roles.INSURANCE">
          <h1 class="lbv-page-title">
            Reports
          </h1>
          <form @submit.prevent="downloadReportsSO">
            <b-button
              variant="primary"
              type="submit"
              class="report rounded-pill"
            >
              <span class="download">Customer Overview</span>
            </b-button>
          </form>
        </b-card>
      </div>
    </div>
    <b-alert
      class="reportErr"
      :show="errorString != &quot;&quot;"
      variant="danger"
    >
      {{ errorString }}
    </b-alert>
  </div>
</template>

<script>
import api from '../api'
import { StatusBarEvent } from '../events/statusBarEvent'
import { EventBus } from '../event-bus'
import { JSONToCSVConvertor, createReportsLabel } from '../utils'
import * as Roles from '../constants/roles.js'

export default {
  name: 'Reports',
  data: function () {
    return {
      errorString: '',
      Roles
    }
  },
  methods: {
    handleError (error) {
      var message = 'The report cannot be downloaded. Please check and try again :: '
      EventBus.$emit(StatusBarEvent.ERROR, message + error.message)
    },
    downloadReports: function (event) {
      var DataApi = {'start_date': '2016-10-10 00:00:00', 'end_date': '2016-10-10 06:00:00'}
      var headings = {
        'v4': 'Surname',
        'v7': 'LeakBot ID',
        'v12': 'Serial Number',
        'v8': 'Post Code',
        'v1': 'Customer Install Date',
        'v2': 'Customer Status',
        'v3': 'Customer Status Change Date',
        'v5': 'Days Since Status Change',
        'v6': 'Leak Status Change Date',
        'v0': 'Battery Level',
        'v10': 'Tenant',
        'v11': 'VIP',
        'v13': 'SMS Allow',
        'v14': 'Phone Allow',
        'v15': 'Post Allow',
        'v16': 'Email Allow',
        'v17': 'Campaign code'
      }

      api.request('post', 'LbReport/Report/CustomerOverview', DataApi)
        .then(response => {
          var JsonData = JSON.stringify(response.data.report.device)
          if (JsonData !== '') {
            var title = createReportsLabel('Customer Overview')
            JSONToCSVConvertor(JsonData, title, true, headings)
          }
        })
        .catch(this.handleError)
    },
    downloadReportsSO: function (event) {
      this.errorString = ''
      var DataApi = {'start_date': '2016-10-10 00:00:00', 'end_date': '2016-10-10 06:00:00'}
      var headings = {
        'v4': 'Surname',
        'v6': 'LeakBot ID',
        'v7': 'Post Code',
        'v1': 'Customer Install Date',
        'v2': 'Customer Status',
        'v3': 'Customer Status Change Date',
        'v5': 'Days Since Status Change',
        'v0': 'Battery Level',
        'v8': 'Tenant',
        'v9': 'Campaign code'
      }

      api.request('post', 'LbReport/Report/SimpleCustomerOverview', DataApi)
        .then(response => {
          var JsonData = JSON.stringify(response.data.report.device)
          if (JsonData !== '') {
            var title = createReportsLabel('Customer Overview')
            JSONToCSVConvertor(JsonData, title, true, headings)
          }
        })
        .catch(this.handleError)
    }
  }
}
</script>
